module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v3/pc/hospital_detail/img_hospital-aa0b98321f492ede80c4d2be6b6039ca.jpg";